import { post, get } from '../libs/Axios';
import { DataLayerUtils } from '../utilities/DataLayer';
import BaseComponent from '../abstracts/BaseComponent';

export default class AddToWishlistComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.SELECT_SIZE_EVENTS.selectedWishlist]: this.setSize,
      [this.CUSTOM_MESSAGES.SELECT_SIZE_EVENTS.selected]: this.setSize,
      [this.CUSTOM_MESSAGES.ADD_TO_WISHLIST_EVENTS.add]: this.addToWishlistFromLayer,
      [this.CUSTOM_MESSAGES.MODAL_EVENTS.afterClose]: this.cleanSize,
    };
  }

  get SELECTORS() {
    return {
      sizesModal: `#js-wishlist-sizes-${this.$options.pid}`,
      modalAdd: '.js-add-to-wishlist'
    };
  }

  get CLASSES() {
    return {
      full: 'is-full',
      error: '.js-error'
    };
  }

  constructor(element) {
    super(element);
    this.isInWishlist = this.$options.inwishlist;
    this.handleClick();
  }

  cleanSize() {
    this.size = null;
  }

  setSize({ sizeSelected, pid }) {
    if (pid && pid.startsWith(this.$options.pid)) {
      console.log('setsize => ', this.$options.pid);
      this.size = sizeSelected;
      this.checkIsLayer();
      this.inWishlist().then((inWishlist) => {
        this.changeStatus(inWishlist);
      });
    }
  }

  async add(params) {
    let success = false;
    try {
      const { data } = await post(this.$options.add, {
        ...params,
        quantity: 1
      });
      success = data.success;
    } catch (error) {
      console.error(error);
    }

    return success;
  }

  async remove(params) {
    let success = false;
    try {
      const { data } = await get(this.$options.remove, {
        params,
      });
      success = data.success;
    } catch (error) {
      console.error(error);
    }

    return success;
  }

  async inWishlist() {
    let res = false;
    try {
      const productId = this.$options.pid.split('_').splice(0, 2).join('_');
      const pid = `${productId}_${this.size}_4`;
      const { data } = await get(this.$options.exist, {
        params: {
          pid
        }
      });
      res = data.itemExists;
    } catch (err) {
      console.error(err);
    }
    return res;
  }

  async removeFromWishlist() {
    const productId = this.$options.pid.split('_').length === 3 ? this.$options.pid : this.$options.pid.split('_').splice(0, 2).join('_');
    const pid = `${productId}${this.size ? `_${this.size}` : ''}`;
    const removed = await this.remove({ pid, quantity: 1 });
    this.changeStatus(!removed);
  }

  addToWishlistFromLayer({ pid, button }) {
    if (pid.startsWith(this.$options.pid)) {
      this.addToWishlist(pid, button);
    }
  }

  async addToWishlist(pid, button) {
    const reqPid = pid || this.$options.pid;
    const productId = reqPid.split('_').length === 3 ? reqPid : reqPid.split('_').splice(0, 2).join('_');
    const pidWishlist = `${productId}${this.size ? `_${this.size}` : ''}`;
    const hasSize = this.$options.pid.split('_').length >= 3;
    this.wishlistId = productId.split('_').join('|');
    if (!this.size && !hasSize) {
      const modal = document.querySelector('.vex');
      const sizeInput = modal.querySelector(this.CLASSES.error);
      sizeInput.classList.remove('hide');
    } else {
      const added = await this.add({ pid: pidWishlist });
      this.changeStatus(added, button);
      if (added) {
        DataLayerUtils.push({
          event: 'asyncAction',
          gaHitType: 'event',
          eventCategory: 'add_to_wishlist',
          eventAction: window.dataLayer[0].pageType,
          eventLabel: productId.split('_').join('|') // var nr. 18,21
        });
      }
    }
  }

  handleClick() {
    this.$on('click', async (e) => {
      try {
        if (!this.$options.cart) {
          const hasSize = this.$options.pid.split('_').length >= 3;
          if (!this.size && !hasSize) {
            this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, {
              selector: this.SELECTORS.sizesModal,
              className: 'modal-50 not-full-height'
            });
          } else {
            const inWishlist = await this.inWishlist();
            if (inWishlist) {
              this.removeFromWishlist();
            } else {
              this.addToWishlist();
            }
          }
        } else if (this.$options.cart) {
          if (this.isInWishlist) {
            this.removeFromWishlist(this.$options.pid).then(() => {
              this.isInWishlist = false;
            });
          } else {
            this.addToWishlist(this.$options.pid).then(() => {
              this.isInWishlist = true;
            });
          }
        }


        // if (this.inWishlist()) {
        //   success = await this.remove();
        // } else {
        //   this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, {
        //     selector: this.SELECTORS.sizesModal,
        //     className: 'modal-50 not-full-height'
        //   });
        // }
      } catch (error) {
        console.error(error);
      }
    });
  }

  changeStatus(inWishlist, button) {
    this.$el.setAttribute('data-in-wishlist', inWishlist);
    this.$el.classList[inWishlist ? 'add' : 'remove'](this.CLASSES.full);
    this.EMIT(this.CUSTOM_MESSAGES.ADD_TO_WISHLIST_EVENTS.modified, {
      pid: this.wishlistId
    });
    if (button && inWishlist) this.endLoading(button, this.$options.successmessage);
    if (inWishlist) setTimeout(() => { this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.close); }, 1000);
  }

  getEndpoint() {
    const isInWishlist = Boolean(this.$el.getAttribute('data-in-wishlist'));

    return this.$options[isInWishlist ? 'remove' : 'add'];
  }

  checkIsLayer() {
    var confirmLayerButton = document.querySelector('[data-component="AddToWishlistLayer"]');
    if (confirmLayerButton) {
      confirmLayerButton.classList.remove('disabled');
    }
  }
}
